(() => {
  const sliderStates = new WeakMap();
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const defaultInterval = 4000;

  const getItems = (bar) => [...bar.querySelectorAll('[data-announcement-item]')];

  const getInterval = (bar) => {
    const interval = Number.parseInt(bar.dataset.announcementInterval, 10);

    return Number.isFinite(interval) && interval >= 2000 ? interval : defaultInterval;
  };

  const setActiveItem = (state, index) => {
    const nextIndex = (index + state.items.length) % state.items.length;

    state.index = nextIndex;
    state.items.forEach((item, itemIndex) => {
      const isActive = itemIndex === nextIndex;

      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-hidden', String(!isActive));
    });

    state.bar.dataset.announcementScheme = state.items[nextIndex]?.dataset.announcementItemScheme || 'black';
  };

  const stopTimer = (state) => {
    if (!state.timer) {
      return;
    }

    window.clearInterval(state.timer);
    state.timer = null;
  };

  const startTimer = (state) => {
    stopTimer(state);

    if (!state.enabled || state.paused || state.items.length < 2 || reducedMotionQuery.matches) {
      return;
    }

    state.timer = window.setInterval(() => {
      setActiveItem(state, state.index + 1);
    }, state.interval);
  };

  const enableSlider = (bar, state) => {
    if (state.items.length < 2) {
      return;
    }

    state.enabled = true;
    bar.classList.add('announcement-bar--slider');
    setActiveItem(state, state.index);
    startTimer(state);
  };

  const disableSlider = (bar, state) => {
    state.enabled = false;
    stopTimer(state);
    bar.classList.remove('announcement-bar--slider');

    state.items.forEach((item) => {
      item.classList.remove('is-active');
      item.removeAttribute('aria-hidden');
    });
  };

  const syncSlider = (bar) => {
    const state = sliderStates.get(bar);

    if (!state) {
      return;
    }

    enableSlider(bar, state);
  };

  const initSlider = (bar) => {
    if (sliderStates.has(bar)) {
      syncSlider(bar);
      return;
    }

    const state = {
      bar,
      enabled: false,
      index: 0,
      interval: getInterval(bar),
      items: getItems(bar),
      paused: false,
      timer: null
    };

    sliderStates.set(bar, state);

    bar.addEventListener('focusin', () => {
      state.paused = true;
      stopTimer(state);
    });

    bar.addEventListener('focusout', () => {
      state.paused = false;
      startTimer(state);
    });

    bar.addEventListener('pointerenter', () => {
      state.paused = true;
      stopTimer(state);
    });

    bar.addEventListener('pointerleave', () => {
      state.paused = false;
      startTimer(state);
    });

    syncSlider(bar);
  };

  const init = (root = document) => {
    root.querySelectorAll?.('[data-announcement-mobile-slider]').forEach(initSlider);
  };

  reducedMotionQuery.addEventListener?.('change', () => {
    document.querySelectorAll('[data-announcement-mobile-slider]').forEach((bar) => {
      const state = sliderStates.get(bar);

      if (state) {
        startTimer(state);
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
